<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">報名表</span>
                        </template>
                        <div class="responsive">
                            <div>
                                <b-form-input v-model="Param.Search.keywords" placeholder="訂單編號搜尋"></b-form-input>
                            </div>
                            <BTableV1 :TablePage="TablePage"
                                :cell="['TotalPrice', 'Create', 'ProductName', 'Date', 'tool']">
                                <template #Create="{ row }">
                                    {{ row.item.Create | datefmt('YYYY-MM-DD') }}
                                    <br />
                                    {{ row.item.Create | datefmt('HH:mm:ss') }}
                                </template>
                                <template #ProductName="{ row }">
                                    <div style="max-width: 200px; white-space: pre-wrap;">
                                        {{ row.item.ProductName }}
                                        <br />
                                        <b-badge v-if="row.item.Dep == '10'">
                                            產才
                                        </b-badge>
                                        <b-badge v-else variant="danger">
                                            非產才
                                        </b-badge>
                                    </div>
                                </template>
                                <template #TotalPrice="{ row }">
                                    <div v-if="row.item.Discount == 0">{{ row.item.TotalPrice | money(0, 2) }}</div>
                                    <div v-if="row.item.Discount != 0">
                                        <div>
                                            <span style="text-decoration: line-through;"> {{ row.item.Price | money(0,
                                                2)
                                            }}</span>
                                        </div>
                                        <div>{{ row.item.TotalPrice | money(0, 2) }}</div>
                                    </div>
                                </template>
                                <!-- <template #Date="{row}">
                                    {{ row.item.Start | datefmt('YYY/YMM/DD') }}~
                                    {{ row.item.End | datefmt('YYYY/MM/DD') }}
                                </template> -->
                                <template #tool="{ row }">
                                    <b-button v-if="row.item.PaymentState == '未付款' && row.item.OrderState == '開放繳費'"
                                        class="mr-3" variant="primary" @click="Pay(row.item)" size="sm">
                                        <span>付款</span>
                                        <span v-if="row.item.PaymentState == '審核中'">修改資料</span>
                                        <!-- <b-icon-cash></b-icon-cash> -->
                                    </b-button>
                                    <b-button class="mr-3" variant="primary" v-if="row.item.PaymentState != '已報名'"
                                        @click="Question(row.item)" size="sm">
                                        <span>調查表</span>
                                    </b-button>
                                </template>
                            </BTableV1>
                        </div>
                        <template v-if="TablePage.items.length > 0">
                            <div class="overflow-auto mt-5">
                                <b-pagination align="center" v-model="Param.Paging.pageNumber" :total-rows="rows"
                                    :per-page="Param.Paging.pageSize"></b-pagination>
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="modalQuestion" ref="modalQuestion" size="lg" hide-footer :title="ProductName + ' - 調查表'">
            <div class="d-block text-start" v-if="QuestionList.dictionary.length > 0">
                <b-form>
                    <div class="item">
                        <b-col cols="12" v-for="(item, index) in QuestionList.dictionary" :key="index">
                            <div class="d-flex" v-if="item.Type == 'text'">
                                <b-form-group :label="item.Name" label-cols="12" class="w-100">
                                    <b-form-input :placeholder="'請填寫' + item.Name"
                                        v-model="Answer[index]"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="d-flex" v-if="item.Type == 'textarea'">
                                <b-form-group :label="item.Name" label-cols="12" class="w-100">
                                    <b-form-textarea :placeholder="'請填寫' + item.Name"
                                        v-model="Answer[index]"></b-form-textarea>
                                </b-form-group>
                            </div>
                            <div class="d-flex" v-else-if="item.Type == 'select'">
                                <b-form-group :label="item.Name" label-cols="12" class="w-100">
                                    <select class="custom-select" v-model="Answer[index]">
                                        <option :value="detail" v-for="(detail, index) in item.Description"
                                            :key="index">{{
                                                detail }}</option>
                                    </select>
                                </b-form-group>
                            </div>
                            <div class="d-flex" v-else-if="item.Type == 'radio'">
                                <b-form-group :label="item.Name" label-cols="12" class="w-100">
                                    <div :id="'radio-group-' + index" role="radiogroup" tabindex="-1"
                                        class="bv-no-focus-ring">
                                        <div v-for="(detail, index2) in item.Description" :key="index2"
                                            class="custom-control custom-control-inline custom-radio">
                                            <input type="radio" v-model="Answer[index]" :name="'radio-' + index"
                                                :value="detail" :id="'radio' + index + index2"
                                                class="custom-control-input" />
                                            <label :for="'radio' + index + index2" class="custom-control-label">
                                                {{ detail }}
                                            </label>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </b-col>
                    </div>
                </b-form>
            </div>
            <b-row class="mt-5">
                <b-col>
                    <b-button class="" variant="outline-danger" block
                        @click="$bvModal.hide('modalQuestion')">關閉</b-button>
                </b-col>
                <b-col><b-button class="" variant="outline-primary" block @click="SaveQuestion()">儲存</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modalPay" ref="modalPay" hide-footer title="匯款資訊填寫">
            <div class="d-block text-start">
                <b-form>
                    <b-form-group>
                        <template #label> <b-badge variant="danger  mt-1 mr-2">必填</b-badge>匯款帳號後五碼 </template>
                        <b-row>
                            <b-col>
                                <b-form-input id="input-1" v-model="PayMent.Number" type="number" placeholder="匯款帳號後五碼"
                                    max-length="5" required></b-form-input></b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group>
                        <template #label> 發票統編 </template>
                        <b-row>
                            <b-col>
                                <b-form-input id="input-1" v-model="PayMent.InvoiceNum" type="number" placeholder="發票統編"
                                    required></b-form-input></b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group>
                        <template #label> 發票抬頭 </template>
                        <b-row>
                            <b-col>
                                <b-form-input id="input-1" v-model="PayMent.InvoiceTitle" type="text" placeholder="發票抬頭"
                                    required></b-form-input></b-col>
                        </b-row>
                    </b-form-group>
                </b-form>
            </div>
            <b-row class="mt-5">
                <b-col>
                    <b-button class="" variant="outline-danger" block @click="$bvModal.hide('modalPay')">關閉</b-button>
                </b-col>
                <b-col><b-button class="" variant="outline-primary" block @click="Save()">儲存</b-button> </b-col>
            </b-row>
        </b-modal>
        <!-- 隱藏的匯款表單 -->
        <div class="row" style="height: 0;width:0;overflow:hidden">
            <form method="post" action="https://service202-sds.fcu.edu.tw/fcupay/depositMenu.aspx" name="resAction">
                <input type="hidden" name="msg" v-model="FucPay" />
            </form>
        </div>
    </div>
</template>
<script>
import nacUser from '@/components/nacUser.vue';
import BTableV1 from '../../components/BTableV1.vue';
import {
    apiGetMember,
    apiOrderDetailList,
    apiOrderDetail,
    apiOrderDetailTransfer,
    apiGetQuestion,
    apiSaveQuestion,
} from '@/api/API.js';

export default {
    name: 'user-signin',
    components: {
        nacUser,
        BTableV1,
    },
    data() {
        return {
            Param: {
                Paging: {
                    pageNumber: 1,
                    pageSize: 10,
                },
                Search: {
                    keywords: this.$store.state.OrderNo,
                },
            },
            pageHeader: '',
            PayMent: {
                Number: '',
                InvoiceNum: '',
                InvoiceTitle: '',
            },
            QuestionList: {
                data: {},
                dictionary: [],
            },
            ProductName: '',
            Answer: [],
            //
            title: '課程報名列表',
            TablePage: {
                title: '',
                class: '',
                BT_style: { striped: true, hover: true },
                PG_style: {
                    pills: true,
                    align: 'center',
                    'first-text': '第一頁',
                    'prev-text': '上一頁',
                    'next-text': '下一頁',
                    'last-text': '最後一頁',
                },
                itemsAll: [],
                items: [],
                id: 'Table1',
                currentPage: 1,
                rows: 100,
                page: 10,
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                fields: [
                    { key: 'Create', label: '報名日期' },
                    { key: 'OrderNo', label: '訂單編號', sortable: false },
                    { key: 'ProductName', label: '課程名稱', sortable: false },
                    { key: 'OrderState', label: '報名狀態', sortable: false },
                    // { key: 'Date', label: '課程時間', sortable: false },
                    { key: 'TotalPrice', label: '金額', sortable: false },
                    { key: 'PaymentState', label: '付款狀態', sortable: false },
                    { key: 'tool', label: '操作', sortable: false },
                ],

                TIndex(th1, index) {
                    return (th1.currentPage - 1) * th1.page + index;
                },
                clear(th1) {
                    th1.itemsAll = [];
                    th1.items = [];
                    th1.rows = 0;
                    th1.currentPage = 1;
                },
                set(th1, data) {
                    th1.itemsAll = JSON.parse(JSON.stringify(data));
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                },
                set2(th1, data) {
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                    th1.currentPage = 1;
                },
                set3(th1, data) {
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                    th1.currentPage = 1;
                },
            },
            Member: {},
            FucPay: '', // 用來綁定 msg 的值

            CurrentProductId: '',
            saving: false,
        };
    },
    watch: {
        'Param.Paging.pageNumber'(newVal) {
            this.GetList(newVal);
        },
        'Param.Search.keywords'(newVal) {
            this.$store.commit('setOrderNo', newVal);
            this.Param.Search.keywords = encodeURI(newVal);
            this.GetList(1);
        },
    },
    created() { },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('尚未登入');
            this._go('/');
        }
        this.Init();
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        cleanCsvValue(v) {
            if (v == null || v == undefined) return '';
            return String(v);
        },
        cleanCsvArray(arr) {
            return Array.isArray(arr) ? arr.map(this.cleanCsvValue) : [];
        },
        Save() {
            // 防連點
            if (this.saving) return;
            if (this.PayMent.Number.length < 5 || this.PayMent.Number.length == '') {
                alert('請輸入匯款帳號後五碼');
            } else {
                apiOrderDetailTransfer(this.PayMent)
                    .then((res) => {
                        console.log(res);
                        alert('儲存成功');
                        // this.FunctionRegistrationSingle();
                        this.hideModal();
                        this.GetList();
                    })
                    .catch((err) => {
                        console.log(err);
                        alert('儲存失敗');
                    });
            }
        },
        Pay(item) {
            // console.log(item);
            // // this.PayMent.Id = id;
            // var SignUp_url = 'https://extension.fcu.edu.tw/FcuPay/FcuPay.aspx';
            // let url = SignUp_url + '?RF_ID=';
            // this._go1(url + item.OrderNo);
            switch (item.Dep) {
                case '10':
                    apiOrderDetail(item.Id)
                        .then((res) => {
                            this.PayMent = res.data;
                            this.$refs['modalPay'].show();
                        })
                        .catch(() => {
                            // alert(err);
                            // alert(err.response.data);
                        });
                    // this.PayMent.PaymentType = 'Counter';
                    break;

                default:
                    // this._go1(url+data.RF_ID)
                    // this.PayMent.PaymentType = 'FCU';
                    // let msg = '你的加密字串或付款參數';
                    this.FucPay = {
                        Dep: '50',
                        Id: this.Member?.User?.NickName || `${this.Member?.User?.LastName || ''}${this.Member?.User?.FirstName || ''}` || '',
                        Amt: item.TotalPrice,
                        Memo: '訂單編號' + item.OrderNo,
                        Sysno: item.Id,
                        Pay: this.Member?.User?.NickName || `${this.Member?.User?.LastName || ''}${this.Member?.User?.FirstName || ''}` || '',
                        CasItem: '500010',
                        Deadline: '',
                        Message: '',
                        PlanNo: item.PlanNo || '',
                        BackUrl: 'http://52.187.19.95/extension/FcuPay/BackPost.aspx', //非必要
                    };
                    // this.FucPay = {
                    //     Dep: '50',
                    //     Id: '測試id',
                    //     Amt: '10',
                    //     Memo: '測試備註',
                    //     Sysno: '測試KEY',
                    //     Pay: '測試付款者',
                    //     CasItem: '500010',
                    //     Deadline: '2020/11/15', //非必要
                    //     Message: '付款完成後顯示的訊息', //非必要
                    //     BackUrl: 'https://www.google.com/', //非必要
                    // };
                    // this.FucPay = {
                    //     Dep: '50',
                    //     Id: '48931033-b100-4793-be56-c6ca232f9afd',
                    //     Amt: 4200,
                    //     Memo: '訂單編號ESN2506251606STV',
                    //     Sysno: '8e755351-0949-4c20-a5b7-9548cf269226',
                    //     Pay: 'Test',
                    //     CasItem: '500010',
                    //     Deadline: '',
                    //     Message: '',
                    //     BackUrl: 'http://52.187.19.95/extension/FcuPay/BackPost.aspx',
                    // };
                    var jsonStr = JSON.stringify(this.FucPay);
                    var b64msg = btoa(unescape(encodeURIComponent(jsonStr))); // 正確編碼防止 UTF-8 問題
                    this.FucPay = b64msg;
                    setTimeout(() => {
                        document.resAction.submit();
                    }, 300);
                    // this.submitFcuPay(item2);
                    break;
            }
        },
        submitFcuPay(msg) {
            this.FucPay = msg;
            this.$nextTick(() => {
                this.$refs.resActionForm.submit(); // 自動提交表單
            });
        },
        Question(item) {
            this.CurrentProductId = item.ProductId;
            this.QuestionList = {
                data: {},
                dictionary: [],
            };
            this.Answer = [];
            this.ProductName = item.ProductName;

            apiGetQuestion(item.ProductId)
                .then((res) => {
                    const q = res.data || {};
                    this.QuestionList.data = typeof q.data === 'object' && q.data !== null ? q.data : {};
                    this.QuestionList.dictionary = Array.isArray(q.dictionary) ? q.dictionary : [];

                    for (const d of this.QuestionList.dictionary) {
                        if ((d.Type === 'radio' || d.Type === 'select') && typeof d.Description === 'string') {
                            try {
                                d.Description = JSON.parse(d.Description);
                            } catch (e) {
                                d.Description = [];
                            }
                        }
                    }

                    const len = this.QuestionList.dictionary.length;
                    const prev = Array.isArray(this.QuestionList.data?.問卷答案) ? this.QuestionList.data.問卷答案 : [];
                    this.Answer = Array.from({ length: len }, (_, i) => prev[i] ?? '');

                    this.$bvModal.show('modalQuestion');
                })
                .catch((err) => {
                    console.log(err);
                    alert('暫無調查表');
                });
        }
        ,
        SaveQuestion() {
            const payload = {
                ProductId: this.CurrentProductId,
                問卷答案: this.Answer || [],
            };

            apiSaveQuestion(payload)
                .then(() => {
                    alert('儲存成功');
                    this.$bvModal.hide('modalQuestion');
                })
                .catch((err) => {
                    console.log(err);
                    alert('儲存失敗');
                });
        }
        ,
        toggleModal() {
            this.hideModal();
        },
        hideModal() {
            this.$refs['modalPay'].hide();
        },
        Init() {
            this.GetList();
            this.GetMember();
        },
        GetList(val) {
            this.TablePage.items = [];
            this.loadSet.show = true;
            if (val) {
                this.Param.Paging.pageNumber = val;
            } else {
                this.Param.Paging.pageNumber = 1;
            }
            apiOrderDetailList(this.Param)
                .then((res) => {
                    this.TablePage.items = res.data;
                    this.pageHeader = JSON.parse(res.headers['list-header']).Paging;
                    this.rows = this.pageHeader.totalCount;
                    this.loadSet.show = false;
                })
                .catch((err) => {
                    this.loadSet.show = false;
                    console.log(err.response);
                });
            // this.apiRegistrationSingle(data_in)
            // .then(res=>{
            //    let json=JSON.parse(res.data)
            //    if(json.Status){
            //       let data1=JSON.parse(json.Data)
            //       this.Clog(data1)
            //       if(data1.length!=0){
            //          for(let i in data1){
            //             let item=data1[i]
            //             if(item.list.length==0){
            //                item.RF_ID=''
            //             }else{
            //                item.RF_ID=item.list[0].RF_ID
            //             }
            //          }
            //          let th1=this
            //          data1.sort((a,b)=>{
            //             return -1*(Number(new Date(th1.str2date3(a.RF_DATE)))-Number(new Date(th1.str2date3(b.RF_DATE))))
            //          })

            //          this.TablePage.set(this.TablePage,data1)
            //          let cps=[]
            //          let pays=[]
            //          for(let i in data1){
            //             cps.push(data1[i].RF_CP_ID)
            //             pays.push(data1[i].RF_PAY_ID)
            //          }
            //          this.FunctionToken(this.FunctionGetCourseFeriodList,{
            //             TYPE:'BATH',
            //             CP_IDS:cps
            //          })

            //          this.FunctionToken(this.FunctionGetStudentPaymentList,{
            //             TYPE:'BATH',
            //             PAY_IDS:pays
            //          })

            //       }
            //    }
            // })
            // .catch(err=>{
            //    this.Elog(err)
            // })
        },
        GetMember() {
            apiGetMember()
                .then((res) => {
                    this.Member = res.data;
                })
                .catch((err) => {
                    alert('尚未登入');
                    console.log(err);
                    this._go('/');
                });
        },
    },
};
</script>
